import { Container } from '../Container/Container'
import logo from '../../assets/ceramol-acn3-logo.png'
import logo2x from '../../assets/ceramol-acn3-logo@2x.png'
import './Footer.css'
import { useTranslate } from '../../TranslationsContext'

export function Footer() {
  const translate = useTranslate()

  return (
    <div className="Footer">
      <Container>
        <p>
          © {new Date().getFullYear()}
          &nbsp;
          {translate('Footer.corporateData')}
          &nbsp;
          <a
            href={translate('Footer.privacyPolicy.url')}
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </p>
        <img
          src={logo}
          srcSet={`${logo} 1x, ${logo2x} 2x`}
          alt="Ceramol Acn3"
        />
      </Container>
    </div>
  )
}
